module.exports = __webpack_public_path__ + "static/img/solutionPic7.2a90f92.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionPic7.png
// module id = txa4
// module chunks = 1